import {  withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import Image from 'next/image';

type AdministrativeStructureProps = ComponentProps & {
  fields:any;
  locale:any
};


const AdministrativeStructure = (props: AdministrativeStructureProps): JSX.Element => {
return(
  <div  className={`relative responsive py-20 ${props?.locale == "ar" ? "rtl" : ""}`}>
    <div id='organizational' className=' absolute -top-28'></div>
    <h1 className='font-bold xl:text-[28px] text-[22px] text-[#0F2837] mb-7'>{props?.fields?.Title?.value}</h1>
<div className='relative w-full min-h-[605px]'>
   <Image className='w-full h-full border ' layout='fill'  objectFit='cover' src={props?.fields?.Image?.value?.src} alt={(props?.fields?.Image?.value?.alt ?? "").trim() || "Administrative structure diagram"}/>
</div>
  </div>
)
}


export default withDatasourceCheck()<AdministrativeStructureProps>(AdministrativeStructure);
